import React from 'react'
import styles from '../../styles/common/Table.module.scss'
import { TableCellProps, TableHeaderProps, TableProps } from '../../types/table'

const Table = ({ children, className }: TableProps) => {
  return (
    <table className={`${styles.tableWrapper} ${className || ''}`}>
      {children}
    </table>
  )
}

Table.Cell = ({ children, className, colSpan, rowSpan }: TableCellProps) => {
  return (
    <td
      colSpan={colSpan}
      rowSpan={rowSpan}
      className={`${styles.tableCell} ${className || ''}`}
    >
      {children}
    </td>
  )
}

Table.Header = ({
  children,
  className,
  colSpan,
  rowSpan,
  scope,
}: TableHeaderProps) => {
  return (
    <th
      scope={scope}
      rowSpan={rowSpan}
      colSpan={colSpan}
      className={`${styles.tableHeader} ${className || ''}`}
    >
      {children}
    </th>
  )
}

Table.Empty = ({ children }: { children: React.ReactNode }) => {
  return <div className={styles.empty}>{children}</div>
}

export default Table
